module.exports = __webpack_public_path__ + "img/1.57c64f81.png";